export default {
  name: 'Custom Properties',
  edit: {
    form: 'quantitative-value-list',
    label: 'Add Custom Properties',
    handler: value => value,
  },
};
